import { type AriaRole, type FC, cloneElement } from 'react';
import classnames from 'classnames';

import { isActionComponent } from '@hh.ru/magritte-ui-action';
import { isLinkComponent } from '@hh.ru/magritte-ui-link';
import { NavigationBarItemProps } from '@hh.ru/magritte-ui-navigation-bar/types';

import styles from './navigation-bar.less';

export const NavigationBarItem: FC<NavigationBarItemProps & { role?: AriaRole; transitionWithOpacity?: boolean }> = ({
    'data-qa': dataQa,
    item,
    transitionWithOpacity,
}) => {
    if (!item) {
        return null;
    }
    const renderItem = dataQa ? cloneElement(item, { 'data-qa': dataQa }) : item;
    if (isActionComponent(item)) {
        return (
            <div className={classnames(styles.icon, { [styles.transitionWithOpacity]: transitionWithOpacity })}>
                {cloneElement(renderItem, {
                    style: 'neutral',
                    mode: 'secondary',
                    showBackground: false,
                    disablePadding: false,
                })}
            </div>
        );
    }
    if (isLinkComponent(item)) {
        return (
            <div className={classnames(styles.label, { [styles.transitionWithOpacity]: transitionWithOpacity })}>
                {cloneElement(renderItem, {
                    mode: 'primary',
                    style: 'accent',
                    type: 'button',
                    element: 'button',
                    underline: 'false',
                })}
            </div>
        );
    }
    return null;
};
